<template>
  <div>
    <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" :close-on-click-modal="false" width="800px">
      <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="140px">
        <el-form-item label="讲师名称：" prop="realName">
          <el-input v-model="form.realName" placeholder="请输入讲师名称" />
        </el-form-item>
        <el-form-item label="性别：">
          <el-radio-group v-model="form.sex">
            <el-radio :label="2">女</el-radio>
            <el-radio :label="1">男</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="头像：" prop="profilePhotoMini">
          <div class="flexs">
            <imageUpload v-model="form.profilePhotoMini" width="42" height="42" />
            <span class="hint hint1">限制上传1张<br />建议尺寸240x300像素以上</span>
          </div>
        </el-form-item>
        <el-form-item label="形象图：" prop="profilePhoto">
          <div class="flexs">
            <imageUpload v-model="form.profilePhoto" width="42" height="42" />
            <span class="hint hint1">限制上传1张<br />建议尺寸750x750像素以上</span>
          </div>
        </el-form-item>
        <el-form-item label="手机号：" prop="mobile">
          <el-input v-model="form.mobile" placeholder="请输入手机号" maxlength="11" />
        </el-form-item>
        <el-form-item v-if="bindingAllowed" label="登录账号：">
          <el-select v-model="form.userId" clearable filterable remote :remote-method="searchAccounts" :loading="bindingLoading" placeholder="搜索后台账号名称">
            <el-option v-for="account in bindingOptions" :key="account.key" :value="account.key" :label="account.value" />
          </el-select>
          <div class="binding-tip">显式绑定后仅可查看负责课程；个人答卷须另行授权。清空可解除绑定。</div>
        </el-form-item>
        <el-form-item label="等级：" prop="levelId">
          <el-select v-model="form.levelId" placeholder="请选择">
            <el-option v-for="item in lecturerLevelOptions" :key="item.id" :label="item.name" :value="item.id" v-if="item.isEnable"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="身份描述：">
          <el-input v-model="form.identityTag" placeholder="请输入身份描述" />
        </el-form-item>
        <el-form-item label="页面排序：" prop="orderNo">
          <el-input v-model="form.orderNo" placeholder="请输入页面排序" />
        </el-form-item>
        <el-form-item label="个人简介：" prop="profileDesc" class="width100">
          <el-input v-model="form.profileDesc" placeholder="请输入个人简介" :rows="6" type="textarea" maxlength="200" show-word-limit />
        </el-form-item>
        <el-form-item label="状态：" prop="isEnable" class="width100">
          <el-switch v-model="form.isEnable" :active-value="true" :inactive-value="false"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取消</el-button>
        <el-button type="primary" @click="doCreate()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import lecturerApi from '@/api/course/lecturer'
import lecturerExamApi from '@/api/course/courseExamLecturer'
import FileUpload from "@/components/FileUpload"
import ImageUpload from "@/components/ImageUpload";
import Editor from "@/components/Editor";
function initFormBean() {
  const formBean = {
    realName: null,
    sex: '',
    profilePhotoMini: null,
    profilePhoto: null,
    mobile: '',
    userId: null,
    bindingConfigured: false,
    levelId: null,
    orderNo: null,
    identityTag: null,
    profileDesc: null,
    isEnable: false,
    isRecommend: 0
  }
  return formBean
}

export default {
  props: ['lecturerLevelOptions'],
  components: { Editor, ImageUpload, FileUpload },
  data() {
    return {
      form: initFormBean(),
      bindingAllowed: false,
      bindingOptions: [],
      bindingLoading: false,
      bindingSearchSeq: 0,
      formVisible: false,
      formRules: {
        realName: [{ required: true, message: '请输入讲师名称', trigger: 'blur' }],
        profilePhotoMini: [{ required: true, message: '请上传头像', trigger: 'change' }],
        profilePhoto: [{ required: true, message: '请上传形象图', trigger: 'change' }],
        levelId: [{ required: true, message: '请选择等级', trigger: 'change' }],
        orderNo: [{ required: true, message: '请输入页面排序', trigger: 'blur' }],
        profileDesc: [{ required: true, message: '请输入个人简介', trigger: 'blur' }],
        isEnable: [{ required: true, message: '请选择状态', trigger: 'blur' }],
        mobile: [{ pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],

      },
      isRepSub: false
    }
  },
  created() {
    lecturerExamApi.bindingCapability().then(({ data }) => {
      this.bindingAllowed = data === true
      if (this.bindingAllowed) this.searchAccounts('')
    })
  },
  beforeDestroy() { this.bindingSearchSeq++ },
  methods: {
    searchAccounts(keyword) {
      const seq = ++this.bindingSearchSeq
      this.bindingLoading = true
      const selected = this.bindingOptions.filter(a => a.key === this.form.userId)
      lecturerExamApi.bindingOptions({ keyword: keyword || undefined }).then(({ data }) => {
        if (seq !== this.bindingSearchSeq) return
        const seen = new Set()
        this.bindingOptions = [...selected, ...(data || [])].filter(a => !seen.has(a.key) && seen.add(a.key))
      }).finally(() => { if (seq === this.bindingSearchSeq) this.bindingLoading = false })
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row, bindingConfigured: false };
      if (row.userId && !this.bindingOptions.some(a => a.key === row.userId)) {
        this.bindingOptions.push({ key: row.userId, value: '后台账号 ID ' + row.userId })
      }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          this.form.bindingConfigured = this.bindingAllowed
          if (this.form.id > 0) {
            lecturerApi.update(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            lecturerApi.create(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.tabType = 1
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
.binding-tip { margin-top: 5px; color: #909399; font-size: 12px; line-height: 1.5; }
.mt {
  margin-top: 10px;
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  padding: 10px 0;
}

.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}

::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none;
}
</style>
